import Inputmask from 'inputmask';
import { isEmpty } from 'lodash-es';

import {
	CURRENCY_PREFIX,
	PERCENTAGE_SUFFIX,
} from '~/converters/number-format-constants';

/**
 * Define all input masks
 *
 * Imported inputmask extension:
 * - numeric.extensions
 * - date.extensions
 */

/**
 * Override default options
 */
Inputmask.extendDefaults({
	// insertMode: 'verbatim',
	placeholder: ' ',
	positionCaretOnTab: false,
	undoOnEscape: false,
});

/**
 * Acurity input masks definitions
 */
Inputmask.extendDefinitions({
	// override with FieldPictureString
	// any character
	X: {
		validator: '.',
	},
	// any except lowercase alpha
	'!': {
		validator: '.',
		casing: 'upper',
	},
	// . (a decimal point)
	'@': {
		validator: '[.]',
	},
	'#': {
		validator: '[0-9-]',
	},
	'9': {
		validator: '[0-9- ]',
	},
});

/**
 * Custom input masks aliases
 *
 * Override these aliases defined from numeric.extensions
 * - currency
 * - decimal
 * - integer
 * - percentage
 *
 * Add these aliases
 * - decimalWithoutAutoGroup
 * - integerWithoutAutoGroup
 *
 * Note: York - Make sure that input mask format is aligned with those in `number-format.ts`
 */
Inputmask.extendAliases({
	currency: {
		prefix: CURRENCY_PREFIX,
		digitsOptional: true,
		placeholder: '0',
	},
	decimal: {
		groupSeparator: ',',
		autoGroup: true,
	},
	integer: {
		autoGroup: true,
		digitsOptional: true,
		groupSeparator: ',',
		// Simply a copy of preValidation method in inputmask.numeric.extensions.js
		// with modified logics of handling negative numbers. The problem of the source
		// code has caused unexpected behavior that when change a negative number to positive
		// user has to add an extra '-' sign
		preValidation(buffer, pos, c, isSelection, opts) {
			if ('-' === c || c === opts.negationSymbol.front) {
				if (c === '-' || c === opts.negationSymbol.front) {
					if (opts.allowMinus !== true) return false;
					opts.isNegative =
						opts.isNegative === undefined ? true : !opts.isNegative;
					if (buffer.join('') === '') return true;
					return { caret: pos, dopost: true };
				}
			}
			if (
				isSelection === false &&
				c === opts.radixPoint &&
				opts.digits !== undefined &&
				(isNaN(opts.digits) || parseInt(opts.digits) > 0)
			) {
				const radixPos = $.inArray(opts.radixPoint, buffer);
				if (radixPos !== -1) {
					if (opts.numericInput === true) {
						return pos === radixPos;
					}
					return { caret: radixPos + 1 };
				}
			}
			// The fix to the unexpected bahavior. When the current buffer is empty
			// or does not contain any non-empty characters, turn opts.isNegative to false
			// automatically.
			if (isEmpty(buffer) || (buffer.length === 1 && buffer[0] === '')) {
				opts.isNegative = false;
			}
			return !0;
		},
	},
	percentage: {
		suffix: PERCENTAGE_SUFFIX,
		clearMaskOnLostFocus: false,
	},
	decimalWithoutAutoGroup: {
		alias: 'decimal',
		autoGroup: false,
	},
	integerWithoutAutoGroup: {
		alias: 'integer',
		autoGroup: false,
		digitsOptional: true,
	},
});
